(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-ppl-countdown]');
  if (root && !root.dataset.bound) {
    root.dataset.bound = 'true';
    const end = Date.parse(root.dataset.end.replace(' ', 'T'));
    const hoursEl = root.querySelector('[data-hours]');
    const minsEl = root.querySelector('[data-mins]');
    const secsEl = root.querySelector('[data-secs]');
    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');
    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      const hours = Math.floor(diff / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    };
    tick();
    setInterval(tick, 1000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-finder"] && !Shopify.designMode) return;
  try {
    
  const form = document.querySelector('[data-pt-finder]');
  if (form && !form.dataset.bound) {
    form.dataset.bound = 'true';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const type = form.querySelector('[data-pt-finder-select]');
      const budget = form.querySelector('[data-pt-finder-budget]');
      if (!type || !type.value) return;
      const url = new URL(type.value, window.location.origin);
      if (budget && budget.value) {
        const extra = new URLSearchParams(budget.value);
        extra.forEach((value, key) => url.searchParams.set(key, value));
      }
      window.location.href = url.pathname + url.search;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playtime-bts"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bts] video').forEach((video) => {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.play().catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  const dialog = document.querySelector('[data-ppl-popup]');
  if (dialog && !dialog.dataset.bound) {
    dialog.dataset.bound = 'true';
    const key = 'ppl-popup-dismissed';
    const dismissed = Number(localStorage.getItem(key) || 0);
    const twoWeeks = 14 * 24 * 60 * 60 * 1000;
    const close = () => {
      dialog.close();
      localStorage.setItem(key, String(Date.now()));
    };
    dialog.querySelector('[data-ppl-popup-close]')?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    if (Date.now() - dismissed > twoWeeks) {
      setTimeout(() => dialog.showModal(), 4500);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-ppl-recent]');
  if (root && !root.dataset.bound) {
    root.dataset.bound = 'true';
    const grid = root.querySelector('[data-ppl-recent-grid]');
    const ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]').slice(0, 8);
    if (!ids.length || !grid) {
      root.hidden = true;
    } else {
      Promise.all(
        ids.map((id) =>
          fetch(`/search/suggest.json?q=id:${id}&resources[type]=product&resources[limit]=1`)
            .then((response) => response.json())
            .catch(() => null)
        )
      ).then((payloads) => {
        const products = payloads
          .map((payload) => payload?.resources?.results?.products?.[0])
          .filter(Boolean);
        if (!products.length) return;
        grid.innerHTML = products
          .map((product) => {
            const featured = product.featured_image;
            const image =
              (typeof product.image === 'string' && product.image) ||
              (featured && typeof featured.url === 'string' && featured.url) ||
              '';
            const price = product.price || '';
            const title = product.title || '';
            return `<a class="ppl-recent__card" href="${product.url}">
              ${image ? `<img src="${image}" alt="${title.replaceAll('"', '&quot;')}">` : ''}
              <span class="ppl-recent__name">${title}</span>
              <span class="ppl-recent__price">${price}</span>
            </a>`;
          })
          .join('');
        root.hidden = false;
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
